<template>
    <BreadCrumb PageTitle="Detail d'une place" />
    <ViewPlace />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
      import ViewPlace from "@/components/Place/ViewPlace.vue";
  
    export default defineComponent({
      name: "ViewPlacePage",
      components: {
        BreadCrumb,
        ViewPlace,
      },
    });
  </script>